
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erfahrungen",
      function () {
        return require("private-next-pages/erfahrungen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erfahrungen"])
      });
    }
  